import SliderDefault from '../SliderDefault'

const SliderV1 = (props) => {
  return <SliderDefault {...props} />
}

export default SliderV1
